// This file is required for each module so that the root projects gulp file
// can include this build and concat this into the "global" javascript

var Tools = require('../../deploynaut/js/tools.jsx');
var SSLCertificates = require('./SSLCertificates.jsx');

Tools.install(SSLCertificates, 'SSLCertificates');
